'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstSubmenuItem = function (_React$Component) {
  _inherits(VstSubmenuItem, _React$Component);

  function VstSubmenuItem(props) {
    _classCallCheck(this, VstSubmenuItem);

    var _this = _possibleConstructorReturn(this, (VstSubmenuItem.__proto__ || Object.getPrototypeOf(VstSubmenuItem)).call(this, props));

    _this.state = {
      style: {},
      visible: _this.props.visible
    };

    _this.calculatePosition = _this.calculatePosition.bind(_this);
    _this.onBackButtonClick = _this.onBackButtonClick.bind(_this);
    _this.focusAtFirstChild = _this.focusAtFirstChild.bind(_this);
    _this.onElementClick = _this.onElementClick.bind(_this);
    return _this;
  }

  _createClass(VstSubmenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.calculatePosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.calculatePosition();
      if (nextProps.isMobile) {
        if (!nextProps.visible) {
          this.setState({ style: { display: 'none' } });
        } else {
          this.setState({ style: { display: 'flex' } });
        }
      }
      this.setState({ visible: nextProps.visible });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          isList = _props.isList,
          children = _props.children;


      return _react2.default.createElement(
        'div',
        { className: 'vst-list submenu', style: _extends({}, style, this.state.style) },
        this.renderMobileHeader(),
        isList ? this.renderList() : children
      );
    }
  }, {
    key: 'onElementClick',
    value: function onElementClick(e, onClick) {
      if (onClick) {
        onClick(e);
      }
      this.props.closeMenu();
    }
  }, {
    key: 'renderList',
    value: function renderList() {
      var _this2 = this;

      return _react2.default.createElement(
        'ul',
        { ref: function ref(submenu) {
            _this2.submenu = submenu;
          } },
        _react.Children.map(this.props.children, function (child) {
          if (!child.props.hidden) {
            return (0, _react.cloneElement)(child, { onClick: function onClick(e) {
                return _this2.onElementClick(e, child.props.onClick);
              } });
          }
          return child;
        }),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement('div', {
            role: 'button',
            tabIndex: 0,
            onFocus: this.focusAtFirstChild
          })
        )
      );
    }
  }, {
    key: 'focusAtFirstChild',
    value: function focusAtFirstChild() {
      if (this.submenu.firstChild.firstChild.focus) {
        this.submenu.firstChild.firstChild.focus();
      } else {
        this.submenu.firstChild.focus();
      }
    }
  }, {
    key: 'onBackButtonClick',
    value: function onBackButtonClick(e) {
      if (this.props.onBackButtonClick) {
        this.props.onBackButtonClick();
      }
      e.stopPropagation();
    }
  }, {
    key: 'renderMobileHeader',
    value: function renderMobileHeader() {
      if (this.props.isMobile) {
        return _react2.default.createElement(
          'header',
          { className: this.props.headerClassName },
          _react2.default.createElement(
            'div',
            { className: 'back-title' },
            _react2.default.createElement(
              'button',
              { className: 'noButton', onClick: this.onBackButtonClick },
              this.props.headerBackButton
            ),
            _react2.default.createElement(
              'h2',
              { tabIndex: 0 },
              this.props.headerTitle
            )
          ),
          _react2.default.createElement(
            'button',
            {
              className: 'noButton',
              onClick: this.onApplyClick
            },
            this.props.headerApplyButton
          )
        );
      }
      return null;
    }
  }, {
    key: 'getWinSize',
    value: function getWinSize() {
      var body = document.body;
      var elem = document.documentElement;
      return {
        innerWidth: window.innerWidth || Math.max(elem.clientWidth, body.clientWidth),
        innerHeight: window.innerHeight || Math.max(elem.clientHeight, body.clientHeight),
        scrollY: window.scrollY || elem.scrollTop || body.scrollTop || 0,
        scrollX: window.scrollX || elem.scrollLeft || body.scrollLeft || 0
      };
    }
  }, {
    key: 'calculatePosition',
    value: function calculatePosition() {
      if (this.props.isMobile) {
        return;
      }
      var submenuNode = (0, _reactDom.findDOMNode)(this);
      var targetNode = (0, _reactDom.findDOMNode)(submenuNode.parentNode);
      var menuNode = (0, _reactDom.findDOMNode)(targetNode.parentNode);
      var menu = menuNode.getBoundingClientRect();
      var target = targetNode.getBoundingClientRect();
      var submenu = submenuNode.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      var windowWidth = window.innerWidth;

      var style = {};
      // Overflows bottom
      var offset = target.top - menu.top;
      if (target.top - offset + submenu.height > windowHeight) {
        style.bottom = target.top - windowHeight + 50;
      } else {
        style.top = offset;
      }

      // Overflows right
      var overflowsRight = menu.left + menu.width + submenu.width > windowWidth;
      var overflowsLeft = menu.left < submenu.width;

      if (overflowsRight && overflowsLeft) {
        style.right = 'unset';
        style.left = windowWidth - menu.width - menu.left - 5;
      } else if (overflowsRight) {
        style.left = 'unset';
        style.right = menu.width;
      } else if (overflowsLeft) {
        style.right = 'unset';
        style.left = menu.width;
      }

      this.setState({ style: style });
    }
  }]);

  return VstSubmenuItem;
}(_react2.default.Component);

VstSubmenuItem.propTypes = {
  children: _propTypes2.default.node.isRequired,
  closeMenu: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number,
  style: _propTypes2.default.object,
  onBackButtonClick: _propTypes2.default.func,
  headerBackButton: _propTypes2.default.node,
  headerTitle: _propTypes2.default.node,
  headerClassName: _propTypes2.default.node,
  headerApplyButton: _propTypes2.default.node,
  isMobile: _propTypes2.default.bool,
  visible: _propTypes2.default.bool,
  isList: _propTypes2.default.bool
};

VstSubmenuItem.defaultProps = {
  headerTitle: 'Submenu Title',
  headerBackButton: 'Back',
  style: {},
  isList: true
};

exports.default = VstSubmenuItem;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstSubmenuItem.js
 **/